import { render, staticRenderFns } from "./atlas_talbe.vue?vue&type=template&id=41012d62&scoped=true&"
import script from "./atlas_talbe.vue?vue&type=script&lang=js&"
export * from "./atlas_talbe.vue?vue&type=script&lang=js&"
import style0 from "./atlas_talbe.vue?vue&type=style&index=0&id=41012d62&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41012d62",
  null
  
)

export default component.exports